module.exports = __webpack_public_path__ + "static/media/landscape.f9ed2b4c.svg";